import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { markActivity } from "@/lib/activity";
import { Loader2 } from "lucide-react";
import { welcomeToast } from "@/lib/welcome";
import { popNext, homeFor } from "@/lib/nextPath";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    const next = popNext();
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        markActivity();
        sessionStorage.removeItem("catalog-filters");
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        welcomeToast(data);
        if (data.needs_role) { navigate("/elegir-perfil"); return; }
        navigate(homeFor(data, next));
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
}
